export default "__VITE_PUBLIC_ASSET__9d0ab003__"